import * as React from 'react';
import { ScoreTypeDataService, SurveyVersionDataService } from '../../services';
import { ScoreType, SurveyVersion } from '../../models';
import { NavLink } from 'react-router-dom';
import { BaseRouteProps } from '../../interfaces';

interface QuestionListState {
    entities: Array<ScoreType>;
    surveyIsPublished: boolean;
}

export class ScoreTypeListing extends React.Component<BaseRouteProps<{ id: number }>, QuestionListState> {
    private scoreTypeDataService = new ScoreTypeDataService(this.props.notificationService);
    private surveyVersionDataService = new SurveyVersionDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{ id: number }>) {
        super(props);

        this.state = {
            entities: new Array<ScoreType>(),
            surveyIsPublished: true
        };
    }

    public componentDidMount() {
        this.surveyVersionDataService.get(this.props.match.params.id).then((surveyVersion: SurveyVersion) => {
            this.setState({
                surveyIsPublished: surveyVersion.published !== null ? true : false
            });

            this.scoreTypeDataService.getAllBySurveyVersion(surveyVersion).then((resp: ScoreType[]) => {
                this.setState({
                    entities: resp
                });
            });
        });
    }

    private sortScoreType(a: ScoreType, b: ScoreType) {
        if (a.sort > b.sort) {
            return 1;
        } else if (a.sort < b.sort) {
            return -1;
        }
        return 0;
    }

    public render() {

        var trueFalseScoreTypes = this.state.entities.filter(entity => {
            return entity.scoringType === 'trueFalse' || entity.scoringType === 'trueFalseInconsistent';
        });

        var likertScoreTypes = this.state.entities.filter(entity => {
            return entity.scoringType === 'likert' || entity.scoringType === 'likertInconsistent';
        });

        var availableAreasTF: string[] = [];
        var areasAddedTF: any = {};
        var availableAreasLikert: string[] = [];
        var areasAddedLikert: any = {};

        trueFalseScoreTypes.map((x: ScoreType) => {
            var area = x.area || '';
            var areaID = area.toLowerCase();
            if (!areasAddedTF[areaID]) {
                areasAddedTF[areaID] = true;
                availableAreasTF.push(area);
            }
        });

        likertScoreTypes.map((x: ScoreType) => {
            var area = x.area || '';
            var areaID = area.toLowerCase();
            if (!areasAddedLikert[areaID]) {
                areasAddedLikert[areaID] = true;
                availableAreasLikert.push(area);
            }
        });

        availableAreasTF.sort((area1: string, area2: string) => {
            if (area1 > area2) {
                return 1;
            } else if (area1 < area2) {
                return -1;
            }
            return 0;
        });

        availableAreasLikert.sort((area1: string, area2: string) => {
            if (area1 > area2) {
                return 1;
            } else if (area1 < area2) {
                return -1;
            }
            return 0;
        });

        return (
            <div>
                <div className="content-header">
                    <div className="content-container">
                        <div className="row">
                            <div className="col-xs-7">
                                <div className="title">
                                    <NavLink to={'/surveyversion/' + this.props.match.params.id}>
                                        <span className="glyphicon glyphicon-triangle-left" />
                                    </NavLink>
                                    &nbsp;
                                    Raw Scores on Survey
                                </div>
                            </div>
                            {!this.state.surveyIsPublished &&
                                <div className="col-xs-5 text-right">
                                    <NavLink className="btn btn-primary" to={'/surveyversion/' + this.props.match.params.id + '/scoretypes/create'}>
                                        <span className="glyphicon glyphicon-plus" /> Create
                                </NavLink>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <div className="row">
                            <div className="col-md-6">
                                <h3>True/False Raw Scores</h3>
                                
                                {availableAreasTF.map((x: string, areaIndex: number) => {
                                    return <table key={`area-tf-${areaIndex}`} className="table table-striped table-scores">
                                        <tbody>
                                            <tr>
                                                <td colSpan={2}>
                                                    <b>{x}</b>
                                                </td>
                                            </tr>
                                            {
                                            trueFalseScoreTypes.filter((s: ScoreType) => {
                                                    var area = s.area || '';
                                                    return area.toLowerCase() === x.toLowerCase();
                                                }).sort(this.sortScoreType).map((score: ScoreType, ursInd: number) => {
                                                    return <tr key={`urs-tf-${areaIndex}-${ursInd}`}>
                                                        <td>
                                                            <NavLink to={`/scoreType/${score.id}`}>
                                                                {score.name}
                                                            </NavLink>
                                                        </td>
                                                        <td className="text-right">
                                                            <NavLink className="btn btn-default" to={`/scoreType/${score.id}`}>
                                                                View
                                                            </NavLink>
                                                        </td>
                                                    </tr>;
                                                })}
                                        </tbody>
                                    </table>;
                                })
                                }
                            </div>
                            <div className="col-md-6">
                                <h3>Likert Raw Scores</h3>
                                
                                {availableAreasLikert.map((x: string, areaIndex: number) => {
                                    return <table key={`area-tf-${areaIndex}`} className="table table-striped table-scores">
                                        <tbody>
                                            <tr>
                                                <td colSpan={2}>
                                                    <b>{x}</b>
                                                </td>
                                            </tr>
                                            {
                                            likertScoreTypes.filter((s: ScoreType) => {
                                                    var area = s.area || '';
                                                    return area.toLowerCase() === x.toLowerCase();
                                                }).sort(this.sortScoreType).map((score: ScoreType, ursInd: number) => {
                                                    return <tr key={`urs-tf-${areaIndex}-${ursInd}`}>
                                                        <td>
                                                            <NavLink to={`/scoreType/${score.id}`}>
                                                                {score.name}
                                                            </NavLink>
                                                        </td>
                                                        <td className="text-right">
                                                            <NavLink className="btn btn-default" to={`/scoreType/${score.id}`}>
                                                                View
                                                            </NavLink>
                                                        </td>
                                                    </tr>;
                                                })}
                                        </tbody>
                                    </table>;
                                })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/scoreType/ScoreTypeListing.tsx